export function buildFlexibleMonthOptions(
  today: Date,
  monthCount: number
): Date[] {
  return Array.from(
    { length: monthCount },
    (_, index) => new Date(today.getFullYear(), today.getMonth() + index, 1)
  );
}
